export default function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 110"
      xmlSpace="preserve">
      <path
        d="M101.8 67.5c-6.7 0-12.5 3.8-15.3 9.4l-26-13c.7-1.9 1.1-3.9 1.1-6 0-2.2-.4-4.4-1.2-6.4L87.5 37c3.1 4.5 8.3 7.5 14.2 7.5 9.5 0 17.2-7.7 17.2-17.2S111.3 10 101.8 10s-17.2 7.7-17.2 17.2c0 2.2.4 4.4 1.2 6.4L58.5 48.2c-3.1-4.5-8.3-7.5-14.2-7.5-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2c6.1 0 11.4-3.1 14.5-7.9l26.4 13.2c-.4 1.4-.6 2.8-.6 4.3 0 9.5 7.7 17.2 17.2 17.2S119 94.3 119 84.8s-7.7-17.3-17.2-17.3zm0-53.7c7.4 0 13.4 6 13.4 13.4s-6 13.4-13.4 13.4-13.4-6-13.4-13.4 6-13.4 13.4-13.4zM44.2 71.3c-7.4 0-13.4-6-13.4-13.4s6-13.4 13.4-13.4 13.4 6 13.4 13.4-6 13.4-13.4 13.4zm57.6 26.9c-7.4 0-13.4-6-13.4-13.4s6-13.4 13.4-13.4 13.4 6 13.4 13.4-6.1 13.4-13.4 13.4z"
        style={{
          fill: '#fff',
        }}
      />
    </svg>
  )
}
